import { Link, usePage } from "@inertiajs/react";
import I from "../Icons";
import { getLanguage, setLanguage, pick } from "../../lib/i18n";

interface Props {
  theme: string;
  toggleTheme: () => void;
  productName?: string | undefined;
  progress?: number | undefined;
  sidebarCollapsed?: boolean;
  onToggleSidebar?: () => void;
}

const copy = {
  pl: { showSidebar: "Pokaż panel boczny", hideSidebar: "Ukryj panel boczny", toggleTheme: "Przełącz motyw", switchLanguage: "Zmień język" },
  en: { showSidebar: "Show sidebar", hideSidebar: "Hide sidebar", toggleTheme: "Toggle theme", switchLanguage: "Change language" },
};

export default function Topbar({ theme, toggleTheme, productName, progress = 0, sidebarCollapsed, onToggleSidebar }: Props) {
  const { app_name, logo_url } = usePage<{ app_name?: string; logo_url?: string | null }>().props;
  const displayName = app_name || "AvantoAI";
  const t = pick(copy);
  const language = getLanguage();

  return (
    <div className="topbar">
      {onToggleSidebar && (
        <button
          className="btn btn-icon btn-sm"
          onClick={onToggleSidebar}
          title={sidebarCollapsed ? t.showSidebar : t.hideSidebar}
          style={{ marginRight: 2 }}
        >
          {I.sidebar}
        </button>
      )}
      <Link href="/" className="logo">
        {logo_url
          ? <img src={logo_url} alt={displayName} style={{ height: 22, width: "auto", borderRadius: 3, objectFit: "contain" }} />
          : <span className="logo-mark" />
        }
        <span>{displayName}</span>
      </Link>
      <div style={{ width: 1, height: 18, background: "var(--line)" }} />
      {productName && (
        <div className="breadcrumb">
          <span className="mono" style={{ fontSize: 11, color: "var(--muted)" }}>workspace</span>
          <span className="sep">/</span>
          <b>{productName}</b>
        </div>
      )}
      <div className="grow" />
      <button
        className="btn btn-icon btn-sm mono"
        onClick={() => setLanguage(language === "pl" ? "en" : "pl")}
        title={t.switchLanguage}
        style={{ fontSize: 11, fontWeight: 600, width: "auto", padding: "0 8px" }}
      >
        {language.toUpperCase()}
      </button>
      <button className="btn btn-icon btn-sm" onClick={toggleTheme} title={t.toggleTheme}>
        {theme === "dark" ? I.sun : I.moon}
      </button>
      <Link href="/settings" className="btn btn-icon btn-sm">{I.settings}</Link>
      {progress > 0 && progress < 100 && (
        <div className="top-progress">
          <div className="bar" style={{ "--p": progress + "%" } as React.CSSProperties} />
        </div>
      )}
    </div>
  );
}
